import dayjs from "dayjs"
import timezone from "dayjs/plugin/timezone"
import utc from "dayjs/plugin/utc"

import Timeframes, { TIMEFRAMES } from "#Utils/timeframes"
dayjs.extend(timezone)
dayjs.extend(utc)

const MINUTE_MS = 60 * 1000
const CLOCK_TIME_FORMAT = "YYYY-MM-DDTHH:mm:ss"
const ZERO_LENGTH_LABEL = "0M"

export const getBaseTimeRange = (baseRange) => {
  const { from: baseFrom, to: baseTo, timeframe } = baseRange
  const presetKey = Timeframes.backwardsCompatibleTimeframeKey(timeframe)

  if (!baseFrom && !baseTo && presetKey) {
    const range = Timeframes.fromToFromTimeframe(presetKey)
    return { from: range.from, to: range.to, timeframe: presetKey }
  } else {
    return { from: baseFrom, to: baseTo, timeframe: null }
  }
}

export const getTimeRangeDiffInMs = (baseRange) => {
  const { from: baseFrom, to: baseTo } = baseRange
  return dayjs(baseTo).diff(dayjs(baseFrom))
}

export const getRangeLengthLabel = (baseRange, timeZone) => {
  const preset = TIMEFRAMES[baseRange.timeframe]

  if (preset) {
    return preset.label
  }

  const start = dayjs(baseRange.from)
  const end = start.add(Math.round(dayjs(baseRange.to).diff(start) / MINUTE_MS), "minute")
  const toClockTime = (date) => dayjs.utc(date.tz(timeZone).format(CLOCK_TIME_FORMAT))
  const clockStart = toClockTime(start)
  const clockEnd = toClockTime(end)
  const isClockTimeBackwards = clockEnd.isBefore(clockStart)
  const from = isClockTimeBackwards ? start.utc() : clockStart
  const to = isClockTimeBackwards ? end.utc() : clockEnd
  const days = to.diff(from, "day")
  const minutes = to.diff(from.add(days, "day"), "minute")
  const parts =
    days > 0
      ? [`${days}D`, `${Math.floor(minutes / 60)}H`]
      : [`${Math.floor(minutes / 60)}H`, `${minutes % 60}M`]

  return parts.filter((part) => !part.startsWith("0")).join(" ") || ZERO_LENGTH_LABEL
}

export const getComparisonEnd = (date, baseRange) => {
  const diff = getTimeRangeDiffInMs(baseRange)

  const dateEnd = dayjs(date).add(diff, "millisecond")
  return dateEnd
}
